import { useEffect, useRef, useCallback } from 'react';
import './agePicker.sass';

type AgePickerComponent = {
  onChange: (age: number) => void;
  count?: number;
  label: string;
};

export default function AgePicker({ onChange, count, label }: AgePickerComponent) {
  const scrollPane = useRef<HTMLDivElement>(null);
  const onScrollEnd = useCallback(() => {
    if (scrollPane.current) {
      const elements = scrollPane.current.querySelectorAll('li');
      const offsets = Array.from(elements).map((el) => el.offsetTop);
      const currentPositon = scrollPane.current.scrollTop + offsets[0];
      const itemHeight = elements[0]?.offsetHeight || 0;
      let currentItem = null;

      for (let i = 0; i < offsets.length; i++) {
        if (offsets[i] <= currentPositon + itemHeight && (offsets[i + 1] > currentPositon + itemHeight || !offsets[i + 1])) {
          currentItem = i;
          break;
        }
      }

      if (currentItem) {
        onChange(currentItem - 1);
      }
    }
  }, [scrollPane, onChange]);

  useEffect(() => {
    const _scrollPane = scrollPane.current;

    if (_scrollPane) {
      _scrollPane.addEventListener('scrollend', onScrollEnd);
    }

    return () => {
      if (_scrollPane) {
        _scrollPane.removeEventListener('scrollend', onScrollEnd);
      }
    };
  }, [onScrollEnd]);

  const items: (string | number)[] = Array.from(Array(count).keys());
  items.unshift(label);

  return (
    <div className="age-picker">
      <div className="age-picker__track-wrap" ref={scrollPane}>
        <ul className="age-picker__track">
          {items.map((val) => (
            <li key={val}>{typeof val === 'string' ? val : val + 1}</li>
          ))}
        </ul>
      </div>
      <div className="age-picker__track-bg" />
      <div className="age-picker__track-selector" />
    </div>
  );
}
